module.exports = __webpack_public_path__ + "static/red-packet.190446ab.png";